import { Component, Input, OnInit } from '@angular/core';
import { Ech0134grundbuchmeldungService, EchGrundbuchmeldungListEntry } from '../../../core/grundbuchmeldung-api';
import { GbPrintService } from '../../../core/services/app-print.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DownloadService } from '../../../core/services/download.service';
import { FormatGeschaeftsnummerPipe } from '../../../shared/pipes/format/format-geschaeftsnummer.pipe';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { ListLoader } from '../../../shared/components/list-loader/list-loader';
import { LinkComponent, NavTarget } from '../../../shared/components/link/link.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ResetCheckModalComponent } from '../../../shared/components/modals/reset-check-modal/reset-check-modal.component';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { DatumZeitPipe } from '../../../shared/pipes/simple/datumZeit.pipe';
import MeldungsStatusEnum = EchGrundbuchmeldungListEntry.MeldungsStatusEnum;

@Component({
  selector: 'cap-ech0134-grundbuchmeldung-table',
  templateUrl: './ech0134-grundbuchmeldung-table.component.html',
  styleUrls: ['./ech0134-grundbuchmeldung-table.component.scss'],
  imports: [
    ListLoaderWrapperComponent,
    ColumnHeaderComponent,
    LinkComponent,
    NgbTooltip,
    DatumZeitPipe,
    FormatGeschaeftsnummerPipe,
    TranslatePipe
  ]
})
export class Ech0134GrundbuchmeldungTableComponent implements OnInit {
  private navTargets = NavTarget;

  @Input()
  showTagebuch: false;
  @Input()
  tableSortModel: TableSortModel<EchGrundbuchmeldungListEntry>;
  @Input()
  listLoader: ListLoader<EchGrundbuchmeldungListEntry>;

  constructor(
    private backend: Ech0134grundbuchmeldungService,
    private translateService: TranslateService,
    private downloadService: DownloadService,
    private geschaeftNummerFormat: FormatGeschaeftsnummerPipe,
    private modalService: NgbModal
  ) {
    keysToTranslate<string>([
      'grundbuchmeldung.datummeldung',
      'grundbuchmeldung.empfaenger.bezeichnung',
      'grundbuchmeldung.meldungsstatus'
    ]);
  }

  ngOnInit() {}

  translateMeldungsStatusEnum(e: MeldungsStatusEnum) {
    return this.translateService.instant('grundbuchmeldung.meldungsstatus.' + e);
  }

  meldungErstellt(item: EchGrundbuchmeldungListEntry): boolean {
    return MeldungsStatusEnum.NICHT_ERSTELLT !== item.meldungsStatus;
  }

  onReset(item: EchGrundbuchmeldungListEntry, button: HTMLButtonElement) {
    button.disabled = true;
    const modal = this.modalService.open(ResetCheckModalComponent);
    modal.componentInstance.entity = this.translateService.instant('ech0134.grundbuchmeldungen.reset.message', {
      geschaeftsnummer: this.geschaeftNummerFormat.transform(item.geschaeftsnummer),
      sedexId: item.empfaengerSedexId
    });
    modal.result.then(
      () => {
        this.backend.resetMeldung(item.meldungId).subscribe(() => {
          this.backend.loadMeldung(item.meldungId.id).subscribe((response) => {
            item.meldungsStatus = response.meldungsStatus;
            item.datumMeldung = response.datumMeldung;
            item.statusResetPossible = response.statusResetPossible;
          });
        });
      },
      () => {
        button.disabled = false;
      }
    );
  }

  onDownload(item: EchGrundbuchmeldungListEntry, button: HTMLButtonElement) {
    button.disabled = true;
    this.downloadService.downloadMeldung(item.meldungId.id).subscribe((data) => {
      GbPrintService.print([data], this.geschaeftNummerFormat.transform(item.geschaeftsnummer) + '_' + item.empfaengerSedexId + '.zip', {
        type: 'application/zip'
      });
      button.disabled = false;
    });
  }
}
